import React, { useState } from 'react';
import cn from 'classnames';
import ReactSelect from 'react-select';
import './Select.scss';
import { Paragraph } from './Typography';
import { SpacingBox, ColumnFlexBox } from './Boxes';
import { getTranslateByScope } from '../i18n';

const TOO_MUCH_OPTIONS = 500;
const MIN_TYPED = 2;
const translate = getTranslateByScope('app.components');

export const Select = ({
  options,
  label,
  onChange,
  placeholder,
  value,
  min,
  isDisabled,
}) => {
  const [selected, setSelected] = useState(value);
  const [text, setText] = useState('');
  const tooManyOptions = options && options.length ? options.length > TOO_MUCH_OPTIONS : null;

  const minTyped = text.length > (min || MIN_TYPED);

  const noOptionsMessage = () => (tooManyOptions && !minTyped
    ? translate('select.min_chars')
    : translate('select.no_results'));

  const optionsControlledWhenTooManyOptions = tooManyOptions && !minTyped ? [] : options;

  const handleChange = (selectedOption) => {
    setSelected(selectedOption);
    onChange(selectedOption);
  };

  return (
    <ColumnFlexBox flex={1}>
      <SpacingBox paddingLeft="sm">
        <Paragraph>{label}</Paragraph>
      </SpacingBox>
      <ReactSelect
        isDisabled={isDisabled}
        onInputChange={(newText) => setText(newText)}
        value={selected}
        options={optionsControlledWhenTooManyOptions}
        className="sch-select"
        classNamePrefix="sch-select"
        onChange={handleChange}
        label={label}
        placeholder={placeholder}
        noOptionsMessage={noOptionsMessage}
      />
    </ColumnFlexBox>
  );
};

Select.defaultProps = {
  options: [],
  label: '',
  onChange: () => {},
};

export const Dropdown = ({
  value,
  onChange,
  label,
  placeholder,
  options,
  noOptionsMessage,
  className,
  getOptionLabel
}) => (
    <ReactSelect
      isSearchable={false}
      value={value}
      options={options || []}
      className={cn('sch-select', className)}
      classNamePrefix="sch-select"
      onChange={(v) => onChange(v)}
      label={label}
      placeholder={placeholder}
      noOptionsMessage={noOptionsMessage}
      getOptionLabel={getOptionLabel}
    />
);

export const DropdownWithLabel = (props) => (
  <>
    <Paragraph className="sch-select-inputLabel">{props.label}</Paragraph>
    <Dropdown className="sch-select-with-label" {...props} placeholder="" />
  </>
);

export const BorderlessInfoDropdown = (props) => (
  <>
    <Dropdown className="sch-borderless-info-dropdown sch-wide-dropdown" {...props} />
  </>
);
